export default {
  locale: 'zh-cn',
  Alert: {
    close: '关闭',
  },
  Calendar: {
    today: '今天',
    now: '此刻',
    confirm: '确认',
    clear: '清除',
    week_days: ['一', '二', '三', '四', '五', '六', '日'],
    week_days_hints: [
      '星期一',
      '星期二',
      '星期三',
      '星期四',
      '星期五',
      '星期六',
      '星期日',
    ],
    last_month: '上个月',
    next_month: '下个月',
    last_year: '去年',
    next_year: '明年',
    last_decade: '上个年代',
    next_decade: '下个年代',
    start_date: '开始日期',
    end_date: '结束日期',
    placeholder: '请选择起止日期',
    year: '年',
    month1: '一月',
    month2: '二月',
    month3: '三月',
    month4: '四月',
    month5: '五月',
    month6: '六月',
    month7: '七月',
    month8: '八月',
    month9: '九月',
    month10: '十月',
    month11: '十一月',
    month12: '十二月',
  },
  Confirm: {
    confirm: '确定',
    cancel: '取消',
  },
  DatePicker: {
    placeholder: '请选择日期',
  },
  Pagination: {
    first_page: '第一页',
    last_page: '最后一页',
    prev_page: '上一页',
    next_page: '下一页',
    prev_5_page: '向前 5 页',
    next_5_page: '向后 5 页',
    goto: '跳至',
    pagesize: '每页 {value} 条',
    total: '共有 {total} 条记录 ',
    current: '第 {current} 页',
    pageClassifier: '页',
  },
  Select: {
    noMatch: '没有找到数据',
    placeholder: '请选择',
    searchPlaceholder: '输入关键字',
  },
  TimePicker: {
    clear: '清除',
    confirm: '确认',
  },
};
